<section>
  <div class="chart-container">
    @if (loading) {
      <div class="loading-spinner">
        <mat-spinner [diameter]="50"></mat-spinner>
      </div>
    }
    <canvas class="chart-canvas" baseChart [data]="pieChartData" [options]="pieChartOptions"
      [labels]="pieChartData.labels" [type]="pieChartType"></canvas>
  </div>
</section>
